export const ASSESSMENT_OFFENSE = `/offence`
export const ASSESSMENT_OFFENSE_LIST_READ_ONLY = `/offence-read`
export const ASSESSMENT_OFFENSE_LIST = `${ASSESSMENT_OFFENSE}/list`
export const ASSESSMENT_REPORT = `/report-misconduct`
